// extracted by mini-css-extract-plugin
export var footerHolder = "Footer-module--footerHolder--2d67p";